export const translations = {
    en: {
      cta_title: "Have a question?",
      cta_description:
        "We're here to help you with any questions you may have. Please fill out the form below and we will get back to you as soon as possible.",
      cta_button: "Tell us about it",

      //navbar
      nav_about: "About",
      nav_services: "Services",
      nav_contact: "Contact",

      //Hero
      hero_title: "Grow faster with AI working as your employee",
      hero_description: "Learn how we’re helping businesses capture the opportunity of AI and automatization.",
      hero_button: "Start working smarter",

      //logo carousel
      logo_carousel_title: "Businesses that have already implemented AI",

      //stacking cards
      stacking_cards_title: "This is how AI has saved businesses millions already",
      stacking_cards_title_1: "Marketing",
      stacking_cards_description_1: "Personalise your messaging and improve your conversion rate by up to 40%",
      stacking_cards_button_1: "Learn more",
      stacking_cards_title_2: "Human Resources",
      stacking_cards_description_2: "Streamline recruitment and onboarding processes while reducing hiring time by 60%",
      stacking_cards_button_2: "Learn more",
      stacking_cards_title_3: "Operations",
      stacking_cards_description_3: "Optimize workflows and reduce operational costs by implementing AI-driven automation",
      stacking_cards_button_3: "Learn more",
      stacking_cards_title_4: "Finance",
      stacking_cards_description_4: "Enhance financial forecasting accuracy and automate reporting with AI-powered analytics",
      stacking_cards_button_4: "Learn more",

      //home services
      home_services_title: "Two ways of working with us",
      home_services_description: "We offer just consulting or complete integration services.",
      home_services_title_1: "AI Consulting",
      home_services_button_1: "Learn more",
      home_services_title_2: "AI Integration",
      home_services_button_2: "Learn more",

     

      //benefits
      benefits_title_3: "Why AI works for your business",
      benefits_title_3_description: "Smarter processes, lower costs, faster results—AI makes it happen.",

      benefits_title_3_1: "Boost Efficiency",
      benefits_title_3_1_description: "Cut manual work and get more done, effortlessly.",

      benefits_title_3_2: "Always On",
      benefits_title_3_2_description: "Serve customers anytime, anywhere—no sleep required.",

      benefits_title_3_3: "Better ROI",
      benefits_title_3_3_description: "AI-driven processes that actually pay off.",

      benefits_title_3_4: "Rock-Solid Security",
      benefits_title_3_4_description: "Protect your data with enterprise-grade safeguards.",

      benefits_title_3_5: "Learns & Improves",
      benefits_title_3_5_description: "Gets smarter over time, just like your best employee.",

      benefits_title_3_6: "Plug & Play",
      benefits_title_3_6_description: "Integrates smoothly with your existing tools.",

      //about
      about_title: "About us",
      about_description: "We are passionate about harnessing the power of Artificial Intelligence to drive innovation and transform businesses. As a dedicated team of AI experts, strategists, and problem-solvers, we specialize in delivering custom AI solutions tailored to your unique challenges and goals.",
      about_title_2: "Our mission",
      about_description_2: "Our mission is to empower businesses with cutting-edge AI solutions that enhance efficiency, drive growth, and deliver exceptional customer experiences. We believe in the transformative potential of AI and are committed to helping organizations harness its full capabilities to stay ahead in a rapidly evolving market.",
      about_title_3: "Our founders",

      //services
      services_hero_title: "You're wasting hours doing things AI could do for you",
      services_hero_description: "We build AI that does the work, so you can focus on growing your business.",
          
      services_card_title_1: "Workflow Automation",
      services_card_title_1_1: "Skip the busywork",
      services_card_title_1_1_description: "Don't let menial tasks stop you. Let AI help you with repetitive tasks like reports, invoices, approvals and more. More flow, less grind.",

      services_card_title_2: "AI Assistant",
      services_card_title_2_1: "Your tireless employee",
      services_card_title_2_1_description: "Stop wasting time on everyday tasks. Let AI handle your scheduling, emails, and summaries. Works 24/7. No coffee breaks needed.",

      services_card_title_3: "Sales & Marketing",
      services_card_title_3_1: "Sell smarter, not harder",
      services_card_title_3_1_description: "Don't spend more in advertizing than you need. Use AI to find leads, personalize outreach, and create content that actually converts.",

      services_card_title_4: "Customer Experience",
      services_card_title_4_1: "A salesman who doesn’t sleep",
      services_card_title_4_1_description: "Don't lose any more customers to unanswered messages. Conversational bots that genuinely understand your customers and communicate naturally. ",

      services_card_title_5: "Social Media Management",
      services_card_title_5_1: "Let AI handle social media",
      services_card_title_5_1_description: "Don’t miss sales by staying silent online. AI schedules posts, replies to comments, and keeps your social presence alive.",

      
      //process
      process_title: "Getting started is easy",
      process_description: "Three simple steps to kickstart your automation journey.",
      process_card_1_title: "Say hi",
      process_card_1_description: "Tell us what you do and where you want to go. We’ll spot the places where AI can make life easier.",
      process_card_2_title: "Hop on a call",
      process_card_2_description: "A short chat to map out your workflows and find the smartest ways to improve them.",
      process_card_3_title: "We make it happen",
      process_card_3_description: "Once we’re aligned, we build, automate, and optimize—so you can focus on what actually matters.",
      process_button: "Get in touch",

      
    
    
    },
    es: {
      cta_title: "¿Tienes una pregunta?",
      cta_description:
        "Estamos aquí para ayudarte con cualquier duda que tengas. Completa el formulario y te responderemos lo antes posible.",
      cta_button: "Cuéntanos",

      //navbar
      nav_about: "Acerca de",
      nav_services: "Servicios",
      nav_contact: "Contacto",

      //Hero
      hero_title: "Crece más rápido con IA trabajando como tu empleado",
      hero_description: "Aprende cómo ayudamos a las empresas a aprovechar la oportunidad de la IA y la automatización.",
      hero_button: "Empieza a trabajar de manera más inteligente",

      //logo carousel
      logo_carousel_title: "Empresas que ya han implementado IA",

      //stacking cards
      stacking_cards_title: "Así es como la IA ya ha ahorrado millones a las empresas",
      stacking_cards_title_1: "Marketing",
      stacking_cards_description_1: "Personaliza tus mensajes y mejora tu tasa de conversión hasta un 40%",
      stacking_cards_button_1: "Más información",
      stacking_cards_title_2: "Recursos Humanos",
      stacking_cards_description_2: "Optimiza los procesos de reclutamiento e integración mientras reduces el tiempo de contratación en un 60%",
      stacking_cards_button_2: "Más información",
      stacking_cards_title_3: "Operaciones",
      stacking_cards_description_3: "Optimiza flujos de trabajo y reduce costos operativos implementando automatización impulsada por IA",
      stacking_cards_button_3: "Más información",
      stacking_cards_title_4: "Finanzas",
      stacking_cards_description_4: "Mejora la precisión de las previsiones financieras y automatiza informes con análisis impulsados por IA",
      stacking_cards_button_4: "Más información",

      //home services
      home_services_title: "Dos formas de trabajar con nosotros",
      home_services_description: "Ofrecemos solo consultoría o servicios completos de integración.",
      home_services_title_1: "Consultoría en IA",
      home_services_button_1: "Más información",
      home_services_title_2: "Integración de IA",
      home_services_button_2: "Más información",

      //benefits
      benefits_title_3: "Por qué la IA funciona para tu negocio",
      benefits_title_3_description: "Procesos más inteligentes, costos más bajos, resultados más rápidos: la IA lo hace posible.",

      benefits_title_3_1: "Aumenta la eficiencia",
      benefits_title_3_1_description: "Reduce el trabajo manual y haz más, sin esfuerzo.",

      benefits_title_3_2: "Siempre disponible",
      benefits_title_3_2_description: "Atiende a tus clientes en cualquier momento y lugar, sin necesidad de descanso.",

      benefits_title_3_3: "Mejor ROI",
      benefits_title_3_3_description: "Procesos impulsados por IA que realmente generan resultados.",

      benefits_title_3_4: "Seguridad sólida",
      benefits_title_3_4_description: "Protege tus datos con medidas de seguridad de nivel empresarial.",

      benefits_title_3_5: "Aprende y mejora",
      benefits_title_3_5_description: "Se vuelve más inteligente con el tiempo, igual que tu mejor empleado.",

      benefits_title_3_6: "Plug & Play",
      benefits_title_3_6_description: "Se integra perfectamente con tus herramientas existentes.",

      //about
      about_title: "Sobre nosotros",
      about_description: "Nos apasiona aprovechar el poder de la Inteligencia Artificial para impulsar la innovación y transformar los negocios. Como un equipo dedicado de expertos en IA, estrategas y solucionadores de problemas, nos especializamos en ofrecer soluciones de IA personalizadas, adaptadas a tus desafíos y objetivos únicos.",
      about_title_2: "Nuestra misión",
      about_description_2: "Nuestra misión es empoderar a las empresas con soluciones de IA de vanguardia que mejoren la eficiencia, fomenten el crecimiento y ofrezcan experiencias excepcionales a los clientes. Creemos en el potencial transformador de la IA y estamos comprometidos a ayudar a las organizaciones a aprovechar todo su poder para mantenerse a la vanguardia en un mercado en constante evolución.",
      about_title_3: "Nuestros fundadores",

      //services
      services_hero_title: "Estás perdiendo horas haciendo cosas que la IA podría hacer por ti",
      services_hero_description: "Creamos IA que hace el trabajo, para que tú puedas concentrarte en hacer crecer tu negocio.",
      
      services_card_title_1: "Automatización de flujos de trabajo",
      services_card_title_1_1: "Olvídate del trabajo rutinario",
      services_card_title_1_1_description: "No dejes que las tareas repetitivas te detengan. Deja que la IA te ayude con informes, facturas, aprobaciones y más. Más fluidez, menos esfuerzo.",

      services_card_title_2: "Asistente de IA",
      services_card_title_2_1: "Tu empleado incansable",
      services_card_title_2_1_description: "Deja de perder tiempo en tareas cotidianas. Deja que la IA se encargue de tus agendas, correos y resúmenes. Funciona 24/7. No necesita café.",

      services_card_title_3: "Ventas y Marketing",
      services_card_title_3_1: "Vende de forma más inteligente, no más difícil",
      services_card_title_3_1_description: "No gastes más en publicidad de lo necesario. Usa IA para encontrar clientes potenciales, personalizar el contacto y crear contenido que realmente convierta.",

      services_card_title_4: "Experiencia del cliente",
      services_card_title_4_1: "Un vendedor que nunca duerme",
      services_card_title_4_1_description: "No pierdas más clientes por mensajes sin respuesta. Bots conversacionales que realmente entienden a tus clientes y comunican de manera natural.",

      services_card_title_5: "Gestión de redes sociales",
      services_card_title_5_1: "Deja que la IA gestione tus redes",
      services_card_title_5_1_description: "No pierdas ventas por estar en silencio online. La IA programa publicaciones, responde comentarios y mantiene viva tu presencia digital.",

      //process
      process_title: "Empezar es fácil",
      process_description: "Tres pasos simples para iniciar tu viaje de automatización.",
      process_card_1_title: "Saluda",
      process_card_1_description: "Cuéntanos lo que haces y hacia dónde quieres ir. Identificaremos dónde la IA puede hacer la vida más fácil.",
      process_card_2_title: "Hablemos",
      process_card_2_description: "Una charla breve para mapear tus flujos de trabajo y encontrar la manera más inteligente de mejorarlos.",
      process_card_3_title: "Lo hacemos realidad",
      process_card_3_description: "Una vez alineados, construimos, automatizamos y optimizamos, para que puedas concentrarte en lo que realmente importa.",
      process_button: "Ponte en contacto",
    },

  };
  